import { stringify } from "query-string";

import handleImageEncode from "./handleImageEncode";
import formatImgixUrl from "./image/formatImgixUrl";
import isImageSrcPreSigned from "./isImageSrcPreSigned";

export default (
  url: string,
  size: number,
  disableLazyLoad = false,
  params?: Record<string, string>,
  isPictureElement = false
) => {
  if (isImageSrcPreSigned(url)) {
    const attributeName = isPictureElement
      ? disableLazyLoad
        ? "srcSet"
        : "data-srcset"
      : disableLazyLoad
      ? "src"
      : "data-src";
    return {
      [attributeName]: url,
    };
  }

  const stringifiedParams = params ? `&${stringify(params)}` : "";

  const source = handleImageEncode(
    `${formatImgixUrl(url)}?auto=compress,format${stringifiedParams}`
  );
  return {
    [disableLazyLoad
      ? "srcSet"
      : "data-srcset"]: `${source}&w=${size}&dpr=1 1x, ${source}&w=${size}&dpr=2 2x`,
  };
};
